//@ts-nocheck
import { Box, ColorOptions, Text } from '@jfs/ui-new'
import { BottomPhone } from '../../../assets/images/svg/BottomPhone'
import { Divider } from '../../../assets/images/svg/Divider'
import { TopPhone } from '../../../assets/images/svg/TopPhone'
import { useStores } from '../../../data/store'
import styles from '../styles'

const ItemView = ({ title, detailText, theme }: { title: string; detailText: string; theme: any }) => {
  return (
    <Box flexDirection="row" pv={2} justifyContent="center" alignItems="center" alignSelf="center">
      <Box alignSelf="flex-start" justifyContent="flex-start" alignItems="center">
        {title === 'Step 1' ? (
          <TopPhone width={118} height={88} color={theme?.brandColor as ColorOptions} />
        ) : (
          <BottomPhone width={118} height={88} color={theme?.brandColor as ColorOptions} />
        )}
        {/* <Image width={118} height={88} resizeMode="contain" source={require(`../../../assets/images/svg/${image}`)} /> */}
      </Box>
      <Box flexDirection="column" flex={1} paddingLeft={16} marginRight={16}>
        <Box
          pv={5}
          ph={20}
          borderRadius={20}
          marginVertical={6}
          backgroundColor={theme?.brandColor as ColorOptions}
          alignSelf="flex-start">
          <Text fontFamily={'jioType-medium'} color={theme?.headingText as ColorOptions}>
            {title}
          </Text>
        </Box>
        <Text {...styles.detailText(theme)} fontFamily={'jioType-medium'} lineHeight={18}>
          {detailText}
        </Text>
      </Box>
    </Box>
  )
}

const VerticalLine = (props) => {
  return <Box {...props} width={1.5} marginLeft={20} />
}

export const PaymentInstructionMobile = () => {
  const { theme } = useStores((root) => ({
    theme: root?.config?.merchantTheme,
  }))

  return (
    <Box width={'80%'} alignSelf={'center'}>
      <ItemView title="Step 1" detailText={'Open your UPI app on your smartphone'} theme={theme} />
      {/* <VerticalLine height={40} backgroundColor={theme?.brandColor as ColorOptions} />
      <VerticalLine height={3} backgroundColor={theme?.headingText as ColorOptions} />
      <VerticalLine height={20} backgroundColor={theme?.brandColor as ColorOptions} />
      <VerticalLine height={2} backgroundColor={theme?.headingText as ColorOptions} />
      <VerticalLine height={10} backgroundColor={theme?.brandColor as ColorOptions} /> */}
      <Box marginLeft={20}>
        <Divider width={2} height={49} color={theme?.brandColor as ColorOptions} />
      </Box>
      <ItemView title="Step 2" detailText={'Complete the payment by entering your UPI PIN'} theme={theme} />
    </Box>
  )
}
